<template>
  <div class="counter">
    <span v-if="second" class="second">
      <span class="val">
        {{ calculatedTime.second }}
      </span>
      <span class="title"> sec </span>
    </span>
    <span v-if="minute" class="minute">
      <span class="val">
        {{ calculatedTime.minute }}
      </span>
      <span class="title"> min </span>
    </span>
    <span v-if="hour" class="hour">
      <span class="val">
        {{ calculatedTime.hour }}
      </span>
      <span class="title"> hours </span>
    </span>
    <span v-if="day" class="day">
      <span class="val">
        {{ calculatedTime.day }}
      </span>
      <span class="title"> days </span>
    </span>
    <span v-if="month" class="month">
      <span class="val">
        {{ calculatedTime.month }}
      </span>
      <span class="title"> month </span>
    </span>
  </div>
</template>

<script>
import { getMoment } from "../helpers/Functions";
export default {
  name: "Counter",
  props: {
    datetime: {
      required: true,
      type: String,
    },
    second: {
      type: Boolean,
      default: true,
    },
    minute: {
      type: Boolean,
      default: true,
    },
    hour: {
      type: Boolean,
      default: true,
    },
    day: {
      type: Boolean,
      default: true,
    },
    month: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      timestamp: 0,
    };
  },
  methods: {
    calcTime() {
      this.timestamp =
        new Date(this.datetime).getTime() -
        new Date(getMoment().format("YYYY-MM-DD HH:mm:ss")).getTime();

      if (this.timestamp <= 0) {
        this.timestamp = 0;
        this.clearTimer();
      }
    },
    startTimer() {
      this.calcTime();
      this.timer = setInterval(() => {
        this.calcTime();
      }, 1000);
    },
    clearTimer() {
      if (this.timer) clearInterval(this.timer);
    },
  },
  computed: {
    calculatedTime() {
      let { timestamp, second, minute, hour, day, month } = this;
      let monthDifference;
      if (month) {
        monthDifference = Math.floor(timestamp / 1000 / 60 / 60 / 24 / 30);
        timestamp -= monthDifference * 1000 * 60 * 60 * 24 * 30;
      }

      let daysDifference;
      if (day) {
        daysDifference = Math.floor(timestamp / 1000 / 60 / 60 / 24);
        timestamp -= daysDifference * 1000 * 60 * 60 * 24;
      }

      let hoursDifference;
      if (hour) {
        hoursDifference = Math.floor(timestamp / 1000 / 60 / 60);
        timestamp -= hoursDifference * 1000 * 60 * 60;
      }

      let minutesDifference;
      if (minute) {
        minutesDifference = Math.floor(timestamp / 1000 / 60);
        timestamp -= minutesDifference * 1000 * 60;
      }

      let secondsDifference;
      if (second) {
        secondsDifference = Math.floor(timestamp / 1000);
      }

      let calculatedTime = {
        month: Math.round(monthDifference),
        day: Math.round(daysDifference),
        hour: Math.round(hoursDifference),
        minute: Math.round(minutesDifference),
        second: Math.round(secondsDifference),
      };

      for (let itm in calculatedTime) {
        if (isNaN(calculatedTime[itm])) calculatedTime[itm] = 0;
        if (calculatedTime[itm] < 10) {
          calculatedTime[itm] = "0" + calculatedTime[itm];
        }
      }

      return calculatedTime;
    },
  },
  mounted() {
    this.startTimer();
  },
  destroyed() {
    this.clearTimer();
  },
};
</script>

<style scoped lang="scss">
.counter {
  display: block;
  overflow: hidden;

  & > span {
    width: 30px;
    height: 30px;
    background: #3e3e3e;
    margin-left: 3px;
    color: #ffffff;
    font-family: sans-serif;
    line-height: 10px;
    float: left;
    text-align: center;
    display: block;
    padding-top: 5px;
    border-radius: 3px;

    &:first-child {
      margin-left: 0;
    }

    .val,
    .title {
      display: block;
    }

    .val {
      font-weight: 700;
    }

    .title {
      font-size: 8px;
      margin-top: 3px;
    }
  }
}
</style>
